import {assertAndContinue} from 'Asserts';
import {assertNever, JSONValue} from 'util/Types';

/**
 * Convert a JSONValue to a user-facing string.
 */
export default function jsonValueToReadable(cell: JSONValue): string {
  if (cell == null) {
    return '';
  } else if (typeof cell === 'boolean' || typeof cell === 'number') {
    return cell.toString();
  } else if (typeof cell === 'string') {
    return cell;
  } else if (typeof cell === 'object') {
    // Handle both JSONObject and JSONArray
    return JSON.stringify(cell, null, 1).replace(/\s+/g, ' ');
  }
  assertAndContinue(false, `Unexpected cell type: ${assertNever(cell)}`);
  return cell;
}
